import React, { useState, useRef } from 'react'
import './design'
import './scripts'
import { ToastContainer, toast } from 'react-toastify'
import Placeholder from 'react-bootstrap/Placeholder'
import Header from './components/config/header'
import Footer from './components/config/footer'
import Socials from './components/config/socials-toolbar'
import Section1 from './components/section1'
import Section2 from './components/section2'
import Section3 from './components/section3'
import Section4 from './components/section4'
import Section5 from './components/section5'
import Section6 from './components/section6'
import Section7 from './components/section7'

function App() {
  const notify = (MSG) => toast(MSG);
  const warning = (MSG) => toast.error(MSG);
  
  // Mock data to bypass CORS errors
  const mockSocials = { body: [
    { platform: "Facebook", link: "#" },
    { platform: "Instagram", link: "#" },
    { platform: "Twitter", link: "#" }
  ]};
  
  const mockAbout = { body: {
    title: "Welcome to Smoky Beach",
    description: "Experience the finest dining with ocean views"
  }};
  
  const mockMenu = { body: [
    { name: "Smoky Burger", price: "$15", description: "Juicy beef patty" },
    { name: "Seafood Platter", price: "$35", description: "Fresh catch of the day" }
  ]};
  
  const mockOutlets = { body: [
    { name: "Downtown", address: "123 Main St" },
    { name: "Beachfront", address: "456 Ocean Ave" }
  ]};
  
  const mockImages = { body: [
    { url: "https://via.placeholder.com/300", alt: "Restaurant" },
    { url: "https://via.placeholder.com/300", alt: "Food" }
  ]};
  
  const mockSlider = { body: [
    { title: "Grand Opening", image: "https://via.placeholder.com/1200x400" },
    { title: "Special Menu", image: "https://via.placeholder.com/1200x400" }
  ]};

  return (
    <div className="App overflow-hidden">
      <div style={{
        background: 'red', 
        color: 'white', 
        padding: '10px',
        textAlign: 'center',
        fontWeight: 'bold'
      }}>
        ⚠️ USING MOCK DATA - CORS BYPASSED ⚠️
      </div>
      
      <Header socials={mockSocials.body} />
      <Socials data={mockSocials.body} />
      <Section1 />
      <Section2 data={mockAbout.body} />
      <Section3 data={mockMenu.body} />
      <div className="parallax">
        <Section4 data={mockOutlets.body} />
        <Section5 data={mockImages.body} />
      </div>
      <Section6 data={mockSlider.body} />
      <Section7 notify={notify} warning={warning} />
      <Footer socials={mockSocials.body} />
      
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
